import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createZoneFailed, createZoneSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createZone(action) {
  try {
    const url = `${BACKEND_URL}/zones`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(createZoneSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createZoneFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createZoneFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
